function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#808285",
  d: "M24407.045 18986.449a1.871 1.871 0 0 1 1.33-3.189 1.765 1.765 0 0 1 1.309.529 1.831 1.831 0 0 1 .566 1.338 1.88 1.88 0 0 1-3.205 1.322zm-7.5 0a1.867 1.867 0 0 1 0-2.637 1.879 1.879 0 0 1 2.639-.023 1.854 1.854 0 0 1 .566 1.338 1.88 1.88 0 0 1-3.205 1.322zm7.5-8.131a1.868 1.868 0 0 1 1.33-3.187 1.764 1.764 0 0 1 1.309.527 1.841 1.841 0 0 1 .566 1.34 1.88 1.88 0 0 1-3.205 1.32zm-7.5 0a1.87 1.87 0 0 1 0-2.639 1.887 1.887 0 0 1 2.639-.021 1.865 1.865 0 0 1 .566 1.34 1.88 1.88 0 0 1-3.205 1.32zm7.5-8.129a1.872 1.872 0 0 1 1.33-3.191 1.758 1.758 0 0 1 1.309.529 1.84 1.84 0 0 1 .566 1.338 1.877 1.877 0 0 1-3.205 1.324zm-7.5 0a1.87 1.87 0 0 1 0-2.639 1.79 1.79 0 0 1 1.328-.553 1.765 1.765 0 0 1 1.311.529 1.864 1.864 0 0 1 .566 1.338 1.877 1.877 0 0 1-3.205 1.324z",
  transform: "translate(-24389.834 -18961.996)"
});

function SvgIconDragIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragIcon);
export default __webpack_public_path__ + "static/media/icon_drag-icon.11fad9cb.svg";
export { ForwardRef as ReactComponent };